import {
  ContentBox,
  ContentBoxHead,
  FormattedHTMLMessage,
  IntegratorRoot,
  Text,
  TextTag,
  ThemeProvider,
} from '@yarmill/components';
import { ReactElement } from 'react';
import { FormattedMessage, IntlProvider } from 'react-intl';
import styled from 'styled-components';
import { getDefaultTranslations } from '../intl/utils/get-default-translations';

const DisabledInstanceWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 20vh;
`;

const CenteredContentBox = styled(ContentBox)`
  max-width: 720px;
  white-space: pre-wrap;
`;

export function DisabledInstance(): ReactElement {
  const { locale, messages } = getDefaultTranslations();

  return (
    <ThemeProvider theme="legacy">
      <IntlProvider locale={locale} messages={messages}>
        <IntegratorRoot>
          <DisabledInstanceWrapper>
            <CenteredContentBox>
              <ContentBoxHead>
                <Text tag={TextTag.h1} bold>
                  <FormattedMessage id="disabledInstance.header" />
                </Text>
              </ContentBoxHead>
              <Text tag={TextTag.p}>
                <FormattedHTMLMessage id="disabledInstance.text" />
              </Text>
            </CenteredContentBox>
          </DisabledInstanceWrapper>
        </IntegratorRoot>
      </IntlProvider>
    </ThemeProvider>
  );
}
